var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosterSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4H14L12 2H6C4.9 2 4.01 2.9 4.01 4L4 16C4 17.1 4.9 18 6 18H22C23.1 18 24 17.1 24 16V6C24 4.9 23.1 4 22 4ZM0 6H2V20H20V22H2C0.9 22 0 21.1 0 20L0.01 11H0V6ZM7 15L11.5 9L15 13.51L17.5 10.5L21 15H7ZM6 16H22V6H13.17L12.58 5.41L11.17 4H6V16Z",
    fill: "#37539D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosterSettingsIcon);
export default __webpack_public_path__ + "static/media/poster-settings-icon.0e2a4da45cd8f1bba7941a56eb091889.svg";
export { ForwardRef as ReactComponent };